import MarkerClusterer from '@google/markerclusterer/src/markerclusterer.js';
import GMapPopup from './GMapPopup.js';

class GMap {

	get_defaults() {
		return {
			zoom: 10,
			center: {lat: -34.397, lng: 150.644},
			styles: [],
			marker_icon : null,
			infowindow_maxwidth: 300,
			cluster: true,
			cluster_icon : null,
			cluster_options : {},
			marker_src: null,
		}
	}
	
	constructor( map_wrap, options ) {

		this.settings = $.extend({}, this.get_defaults(), (options !== undefined ? options : {}));

		this.map_wrap = map_wrap;
		this.$map_wrap = $(map_wrap);

		if(this.$map_wrap.find('.map').length) {
			return;
		}

		this.$map_el = $('<div class="map"></map>');

		this.$map_el.appendTo(this.$map_wrap);
		this.map_el = this.$map_el[0];

		this.marker_cluster = null;
		this.markers = {};
		this.infowindows = [];
		this.popups = [];
		this.bounds = new google.maps.LatLngBounds();

		this.init_map();

		this.$map_wrap.data('gmap', this);

	}

	update() {
		this.render_markers();
	}

	get_marker_els() {
		/*var marker_src = this.settings.marker_src,
			$marker_src = this.$map_wrap;

		if(marker_src === null) {
			let marker_src = this.$map_wrap.data('marker-src');
			if(marker_src) {
				$marker_src = $(marker_src);
			}
		}
*/
		return this.$map_wrap.find('.map-marker');
		// return $marker_src.find('.map-marker');
	}



	init_map() {

		/*global google  */


		var map_settings = {
			zoom: this.settings.zoom,
		};

		if(this.settings.center) {
			map_settings.center = this.settings.center;
		}

		if(this.settings.styles.length) {
			map_settings.styles = this.settings.styles;
		}

		var map = new google.maps.Map(this.map_el, map_settings);

		this.map = map;

		this.render_markers();

	}

	render_markers() {
		GMapPopup.prototype = Object.create(google.maps.OverlayView.prototype);

		var new_markers = [],
			new_infowindows = [],
			new_popups = [];
		// 	bounds = new google.maps.LatLngBounds();

		var map = this.map;
		//console.log('this.get_marker_els()', this.get_marker_els());
		this.get_marker_els().each((i, el) => {

			var $marker_el = $(el),
				lat = parseFloat($marker_el.data('lat')),
				lng = parseFloat($marker_el.data('lng')),
				marker_id = $marker_el.data('marker-id') || i,
				position = {lat: lat, lng: lng},
				LatLng = new google.maps.LatLng(lat, lng),
				infobox_content = $marker_el.html();
				// infobox_title = $marker_el.data('title');
			if(this.markers['m_' + marker_id]) {
			// if($marker_el.hasClass('marker-rendered')) {
				return;
			}

			var marker_settings = {
				position: position, 
				animation: google.maps.Animation.DROP,
				map: map,
				optimized: false,
			};

			marker_settings.icon = this.settings.marker_icon;

			var marker = new google.maps.Marker(marker_settings);
			infobox_content = infobox_content.trim();
			//infobox_content = '<div class="box"><div class="box__image" style="background-image: url(css/images/temp/box-image1.jpg)"></div><div class="box__content"><h3>Centre Name</h3><p>Description of Centre to go here over two lines</p><a href="/centre-single.php" class="btn btn--white btn--padding hidden-xs">Find out more</a><a href="/centre-single.php" class="link-more hidden-sm hidden-md hidden-lg"><span>Learn more</span><i class="ico-next-white-purple"></i></a></div></div>';

			if(infobox_content != undefined && infobox_content.length) {
				/*var popup = new GMapPopup(
					new google.maps.LatLng(lat, lng),
					$(infobox_content).get(0)
				);
				
				popup.setMap(map);
				popup.close();
				
				marker.addListener('click', () => {
					$.each(this.popups, function(j, popup){
						console.log('click');
						popup.close();
					});

					popup.open(map, marker);
					$(window).trigger('resize');
					map.panTo({lat: lat, lng: lng});
					map.panBy(0,-100);
				});
				
				new_popups.push(popup);

				this.popups.push(popup);*/
				// var activeWindow;
				var infowindow = new google.maps.InfoWindow({
					content: infobox_content,
					maxWidth: 188,
		        });

		        marker.addListener('click', () => {
		        	
		        	/*if(this.activeWindow = null) {
						this.activeWindow.close(); 
					}
				    console.log(this.activeWindow);	*/
					if(this.activeWindow != null) {
						this.activeWindow.close(); 
					}

				    infowindow.open(map, marker); 
				    $(window).trigger('resize');
					map.panTo({lat: lat, lng: lng});
					map.panBy(0,-100);
				    
				    this.activeWindow = infowindow; 
				});

			}

			new_markers.push(marker);
			this.markers['m_' + marker_id] = marker;
			this.bounds.extend(LatLng);
			
			$marker_el.addClass('marker-rendered');

		});
		
		var marker_object_values = Object.keys(this.markers).map(itm => this.markers[itm]);
		/*console.log('marker_object_values', marker_object_values);*/
		if( marker_object_values.length > 50 ) {
		// if(Object.values(this.markers).length > 1) {

			map.fitBounds(this.bounds);
			/*if( marker_object_values.length == 1 ) {
				map.setZoom(this.settings.zoom);
			}*/
			if (map.getZoom() > 12) map.setZoom(12);
			if( marker_object_values.length == 1 ) {
				var listener = google.maps.event.addListener(map, 'idle', function() { 
					if (map.getZoom() > 12) map.setZoom(12);
					google.maps.event.removeListener(listener);
				});
			}

			if(this.settings.cluster) {
				var cluster_options = this.settings.cluster_options;

				// if(this.settings.cluster_icon) {
				// 	cluster_options.imagePath = this.settings.cluster_icon;
				// }
				if(this.marker_cluster) {
					this.marker_cluster.clearMarkers();
				}
				this.marker_cluster = new MarkerClusterer(map, marker_object_values, cluster_options);
				// var markerCluster = new MarkerClusterer(map, markers,
      
			}

			if( marker_object_values.length == 1 ) {
				map.setZoom(this.settings.zoom);
			}

		}

		if(new_popups.length > 0) {
			map.addListener('click', function(){
				$.each(new_popups, function(i, popup){
					popup.close();
				});
			});
		}
		if(new_infowindows.length > 0) {
			map.addListener('click', function(){
				$.each(new_infowindows, function(i, infowindow){
					infowindow.close();
				});
			});
		}
	}

	infobox_reset(infowindow) {

		// *
		// START INFOWINDOW CUSTOMIZE.
		// The google.maps.event.addListener() event expects
		// the creation of the infowindow HTML structure 'domready'
		// and before the opening of the infowindow, defined styles are applied.
		// *
		/*global google */

		google.maps.event.addListener(infowindow, 'domready', function() {

			// Reference to the DIV that wraps the bottom of infowindow
			var iwOuter = $('.gm-style-iw');

			/* Since this div is in a position prior to .gm-div style-iw.
			* We use jQuery and create a iwBackground variable,
			* and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
			*/
			var iwBackground = iwOuter.prev();

			// Removes background shadow DIV
			iwBackground.children(':nth-child(2)').css({'display' : 'none'});

			// Removes white background DIV
			iwBackground.children(':nth-child(4)').css({'display' : 'none'});

			// Moves the infowindow 115px to the right.
			/*iwOuter.parent().parent().css({
					height: iwOuter.find('article').outerHeight(),
					width: iwOuter.find('article').outerWidth(),
				});*/

			// // Moves the shadow of the arrow 76px to the left margin.
			// iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

			// // Moves the arrow 76px to the left margin.
			// iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

			// // Changes the desired tail shadow color.
			// iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

			// Reference to the div that groups the close button elements.
			// var iwCloseBtn = iwOuter.next();
			/*
			// Apply the desired effect to the close button
			iwCloseBtn.css({opacity: '1', right: '38px', top: '3px', border: '7px solid #48b5e9', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});

			// If the content of infowindow not exceed the set maximum height, then the gradient is removed.
			if($('.iw-content').height() < 140){
			$('.iw-bottom-gradient').css({display: 'none'});
			}

			// The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
			iwCloseBtn.mouseout(function(){
			$(this).css({opacity: '1'});
			});*/
		});
	}
}


export default GMap



// WEBPACK FOOTER //
// ./scripts/util/GMap.js